import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { get } from "../../common/utilities/object";
import { DocumentSetData } from "../interfaces/documentSet";
import { ColumnItem } from "../interfaces/overview";
import { parseSearchableString } from "../utils/searchableParser";
import { getInLanguageOrDefault } from "../../common/utilities/language";
import { Translation } from "../../configMap";

const EMPTY_VALUE = "-";

const useCellValue = (documentSet: DocumentSetData, columnItem: ColumnItem) => {
  const {
    i18n: { language },
  } = useTranslation();

  return useMemo(() => {
    const source = columnItem?.metadata?.source?.toLowerCase();

    if (source === "searchable") {
      return parseSearchableString(documentSet.searchable, columnItem.key);
    }

    // The cell holds a config record (e.g. the hold reason), labelled per language here.
    if (source === "translations") {
      const record = get(documentSet, columnItem.key, "") as {
        translations: Translation;
      } | null;

      if (!record) {
        return EMPTY_VALUE;
      }

      return getInLanguageOrDefault(record.translations, language, EMPTY_VALUE);
    }

    return get(documentSet, columnItem.key, "N/A");
  }, [documentSet, columnItem, language]);
};

export default useCellValue;
